module.exports = __webpack_public_path__ + "media/images/shared/logo-8e13d9c92921c7be0714f9b11dd0f9eb.png";